var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPedidoConfirmado = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8501 8.44444H22.0001V6.22222C22.0001 4.995 21.015 4 19.8001 4H14.8501V8.44444Z",
    fill: "#64B5F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7998 4H5.4998C4.28485 4 3.2998 4.995 3.2998 6.22222V21.7778C3.2998 23.005 4.28485 24 5.4998 24H15.3998C16.6148 24 17.5998 23.005 17.5998 21.7778V6.22222C17.5998 4.995 18.5849 4 19.7998 4Z",
    fill: "#BBDEFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 24H2.2C0.98505 24 0 23.005 0 21.7778V20.1111H13.2V21.7778C13.2 23.005 14.1851 24 15.4 24ZM6.6 8.44446H14.3V9.55557H6.6V8.44446ZM6.6 11.2222H12.1V12.3333H6.6V11.2222ZM6.6 14H14.3V15.1111H6.6V14ZM6.6 16.7778H12.1V17.8889H6.6V16.7778Z",
    fill: "#64B5F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6C24 9.3135 21.3135 12 18 12C14.6865 12 12 9.3135 12 6C12 2.6865 14.6865 0 18 0C21.3135 0 24 2.6865 24 6Z",
    fill: "#17CF63"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1809 3.18073L17.1003 7.25982L15.4197 5.58042L14.5806 6.41952L17.1003 8.94041L22.0197 4.01982L21.1809 3.18073Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPedidoConfirmado, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PedidoConfirmado.60cac0c4.svg";
export { ForwardRef as ReactComponent };